export enum CardTypeEnums {
    MasterCard = 'mastercard',
    Visa = 'visa',
    AmericanExpress ='american-express',
    maestro ='maestro',
    others = ''
}